import {Field} from 'formik';

import {SimpleGrid} from '@mantine/core';
import {CustomersAutocomplete} from "../../customers/inputs/CustomersAutocomplete.tsx";


export const FormComponent = () => {

    return (
        <SimpleGrid cols={1}>

            <Field
                name='customerId'
                label='Customer'
                description='Please enter the customer'
                component={CustomersAutocomplete}
                withAsterisk
            />

        </SimpleGrid>
    );
};
